import React from 'react';
// import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';

function ToastNotification({ show, setShow, typeMsg, notifyMessage }) {
  return (
    <>
      {show &&
        <div className='tre_toastInfo'>
          <Row>
            <Col xs={12}>
              <Toast className='w-100' onClose={() => setShow(false)} show={show} delay={3000} autohide>
                <Toast.Body className={(typeMsg === 'success' && 'bg-success text-white tre_radius-4') || (typeMsg === 'undefined' && 'bg-danger text-white tre_radius-4')}>{notifyMessage}</Toast.Body>
              </Toast>
            </Col>
          </Row>
        </div>}
    </>
  );
}

export default ToastNotification;